import BrandPreview from "components/BrandPreview/BrandPreview";

export default BrandPreview;